// src/utils/roleMapper.js

// Converts human-readable role → backend permission flags
export function roleToPermissions(role) {
  switch (role) {
    case 'owner':
      return { can_edit: true, can_comment: true }
    case 'editor':
      return { can_edit: true, can_comment: true }
    case 'viewer':
    default:
      return { can_edit: false, can_comment: true }
  }
}

// Converts backend flags → human-readable role
export function permissionsToRole({ can_edit, can_comment }) {
  if (can_edit && can_comment) return 'editor' // or 'owner' if you're distinguishing later
  if (!can_edit && can_comment) return 'viewer'
  return 'custom'
}